<template>
  <div class="container partner-signup">
    <form-wizard @on-complete="onComplete"
                  @on-change="scrollToTop"
                  ref="wizard"
                  shape="tab"
                  back-button-text="Go back!"
                  next-button-text="Continue"
                  finish-button-text="Sign Up"
                  color="#eff9ff">
        <h1 slot="title" class="amcredit-font minimal-title text-center text-12-16 f-w-600 color-grey-5 uppercase ls-1">Partner Program Sign Up</h1>
        <tab-content icon="far fa-hospital" :before-change="validateFirstTab">
          <h3 class="title">Complete the form below to partner with the fastest growing provider of small business loans.</h3>
          <h5 class="color-green">Business Owner Details</h5>
          <vue-form-generator :model="model" 
                              :schema="businessOwnerSchema"
                              :options="formOptions"
                              ref="businessOwnerForm"
                              >                        
          </vue-form-generator>
          <h5 class="color-green">Company Information</h5>
          <vue-form-generator :model="model" 
                              :schema="companyInfoSchema"
                              :options="formOptions"
                              ref="companyInfoForm"
                              >                        
          </vue-form-generator>
          <h5 class="color-green">About Your Company</h5>
          <vue-form-generator :model="model" 
                              :schema="aboutCompanySchema"
                              :options="formOptions"
                              ref="aboutCompanyForm"
                              >                        
          </vue-form-generator>
          <h5 class="color-green">Lending Experience</h5>
          <vue-form-generator :model="model" 
                              :schema="lendingExpSchema"
                              :options="formOptions"
                              ref="lendingExpForm"
                              >                        
          </vue-form-generator>
        </tab-content>
    </form-wizard>
  </div>
  
</template>

<script>
// import Vue from 'vue'
import { mapGetters, mapActions, mapMutations } from "vuex";
import { Loading } from "element-ui";
import * as types from "../vuex/types";
import VueFormGenerator from 'vue-form-generator'
import Cookie from 'js-cookie';
import 'vue-form-generator/dist/vfg.css'
import api from "../vuex/api/index";
import axios from 'axios';
import Cleave from 'cleave.js';
import moment from 'moment';
import { validators } from "vue-form-generator";

// Vue.use(VueFormGenerator)

export default {
  name: "ApplyForm",
  components: {
    "vue-form-generator": VueFormGenerator.component
	},
  data () {
    return {
      owner2Toggle: true,
      showOwner2: false,
      displayCreditReport: false,
      displayContactYou: false,
      uploadedFiles: null,
      addOwners:[],
      consentToggle: false,
      toggle: true,
      brokerNote: '',
      model:{
        dateOfBirth:'',
        companyName:'',
        FederalID:'',
        address:'',
        address2:'',
        city:'',
        state:null,
        zip:'',
        companyEmail:'',
        companyPhone:'',
        stateOfIncorporation:null,
        yearsInBusiness:'',
        businessDescription:null,
        reasonForEquipment:null,
        taxClassification:null,
        firstName:'',
        lastName:'',
        ssn:'',
        ownership:'',
        personalEmail:'',
        personalPhone:'',
        ownerAddress:'',
        ownerAddress2:'',
        ownerCity:'',
        ownerState:null,
        ownerZip:''
      },
   formOptions: {
    validationErrorClass: "has-error",
    validationSuccessClass: "has-success",
    validateAfterChanged: true
   },
   businessOwnerSchema:{
     fields:[
      {
        type: "input",
        inputType: "text",
        label: "First Name",
        model: "firstName",
        required: true,
        validator: ["string", "required"],
        styleClasses:'col-lg-4 custom-input'
      },
      {
        type: "input",
        inputType: "text",
        label: "Last Name",
        model: "lastName",
        required: true,
        validator: ["string", "required"],
        styleClasses:'col-lg-4 custom-input'
      },
      {
        type: "input",
        inputType: "email",
        label: "Email",
        model: "personalEmail",
        required:true,
        validator:VueFormGenerator.validators.email,
        styleClasses:'col-lg-4 custom-input'
      },
      {
        type: "cleave",
				inputType: "text",
        model: "dateOfBirth",
        label: "Date of Birth",
        required:true,
        min: 10,
        validator: validators.string.locale({
          fieldIsRequired: "This field is required!",
          textTooSmall: "Please input a valid date."
        }),
        cleaveOptions: {
          blocks: [2, 2, 4],
          delimiters: ["-", "-"],
          numericOnly: true
        },
        styleClasses:'col-lg-4 custom-input'
      },
      {
        type: "input",
				inputType: "text",
        label: "Home Address Line 1",
        model: "ownerAddress",
        required: true,
        validator: ["string", "required"],
        styleClasses: 'col-lg-4 custom-input'
      },
      {
        type: "input",
				inputType: "text",
        label: "Home Address Line 2",
        model: "ownerAddress2",
        validator: ["string"],
        styleClasses: 'col-lg-4 custom-input'
      },
      {
        type: "input",
				inputType: "text",
        label: "City",
        model: "ownerCity",
        required: true,
        validator: ["string", "required"],
        styleClasses: 'col-lg-4 custom-input'
      },
      {
        type: 'select',
        label: 'State',
        placeholder: 'Choose...',
        model: 'ownerState',
        required: true,
        validator: "required",
        values: ['Alabama','Alaska','Arizona','Arkansas','California','Colorado','Connecticut','Delaware','Florida','Georgia','Hawaii','Idaho','Illinois','Indiana','Iowa','Kansas','Kentucky','Louisiana','Maine','Maryland','Massachusetts','Michigan','Minnesota','Mississippi','Missouri','Montana','Nebraska','Nevada','New Hampshire','New Jersey','New Mexico','New York','North Carolina','North Dakota','Ohio','Oklahoma','Oregon','Pennsylvania','Rhode Island','South Carolina','South Dakota','Tennessee','Texas','Utah','Vermont','Virginia','Washington','West Virginia','Wisconsin','Wyoming'],
        selectOptions: {
          noneSelectedText: "Choose..."
        },
        styleClasses:'col-lg-4 custom-input',
        onChanged: function(model, newVal, oldVal, field) {
          field.styleClasses = field.styleClasses + ' selected';
        }
      },
      {
        type: "cleave",
				inputType: "text",
        model: "ownerZip",
        label: "Home Address Zip Code",
        required:true,
        min: 5,
        validator: validators.string.locale({
          fieldIsRequired: "This field is required!",
          textTooSmall: "Please input a valid zip."
        }),
        cleaveOptions: {
          blocks: [5],
          numericOnly: true
        },
        styleClasses:'col-lg-4 custom-input'
      },
      {
        type: "cleave",
        inputType: "text",
        label: "SSN",
        model: "owner2Ssn",
        required:true,
        min: 9,
        validator: validators.string.locale({
          fieldIsRequired: "This field is required!",
          textTooSmall: "Please input a valid SSN."
        }),
        cleaveOptions: {
          blocks: [9],
          numericOnly: true
        },
        // hint: 'We conduct soft credit pull only. It will not affect your credit score.',
        styleClasses:'col-lg-4 custom-input'
      }
     ]
   },
   companyInfoSchema: {
     fields: [
      {
        type: "input",
        inputType: "text",
        label: "Company Name",
        model: "companyName",
        required: true,
        validator: ["string", "required"],
        styleClasses:'col-lg-4 custom-input'
      },
      {
        type: "cleave",
        inputType: "text",
        label: "Company Phone",
        model: "companyPhone",
        required:true,
        min: 13,
        validator: validators.string.locale({
          fieldIsRequired: "This field is required!",
          textTooSmall: "Please input a valid number."
        }),
        cleaveOptions: {
          blocks: [0, 3, 3, 4],
          delimiters: ["(", ")", "-"],
          numericOnly: true
        },
        styleClasses:'col-lg-4 custom-input'
      },
      {
        type: "input",
        inputType: "text",
        label: "Website",
        model: "website",
        validator: ["string"],
        styleClasses:'col-lg-8 custom-input custom-lg-8'
      },
      {
        type: "input",
				inputType: "text",
        label: "Business Legal Address",
        model: "address",
        required: true,
        validator: ["string", "required"],
        styleClasses: 'col-lg-4 custom-input'
     },
     {
        type: "input",
				inputType: "text",
        label: "City",
        model: "city",
        required: true,
        validator: ["string", "required"],
        styleClasses: 'col-lg-4 custom-input'
     },
     {
        type: 'select',
        label: 'State',
        placeholder: 'Choose...',
        model: 'state',
        required: true,
        validator: "required",
        values: ['Alabama','Alaska','Arizona','Arkansas','California','Colorado','Connecticut','Delaware','Florida','Georgia','Hawaii','Idaho','Illinois','Indiana','Iowa','Kansas','Kentucky','Louisiana','Maine','Maryland','Massachusetts','Michigan','Minnesota','Mississippi','Missouri','Montana','Nebraska','Nevada','New Hampshire','New Jersey','New Mexico','New York','North Carolina','North Dakota','Ohio','Oklahoma','Oregon','Pennsylvania','Rhode Island','South Carolina','South Dakota','Tennessee','Texas','Utah','Vermont','Virginia','Washington','West Virginia','Wisconsin','Wyoming'],
        selectOptions: {
          noneSelectedText: "Choose..."
        },
        styleClasses:'col-lg-4 custom-input',
        onChanged: function(model, newVal, oldVal, field) {
          field.styleClasses = field.styleClasses + ' selected';
        }
     },
     {
        type: "cleave",
				inputType: "text",
        model: "zip",
        label: "Zip Code",
        required:true,
        min: 5,
        validator: validators.string.locale({
          fieldIsRequired: "This field is required!",
          textTooSmall: "Please input a valid zip."
        }),
        cleaveOptions: {
          blocks: [5],
          numericOnly: true
        },
        styleClasses:'col-lg-4 custom-input'
      },
      {
        type: 'select',
        label: 'Company Type',
        placeholder: 'Choose...',
        model: 'taxClassification',
        values: ['C corp', 'Federal Government', 'Limited Liability Partnership', 'Limited Liability Limited Partnership', 'LLC', 'Non Profit', 'Partnership', 'Professional Corporation', 'S Corp', 'Sole Prop', 'State/Local Government', 'Other'],
        required:true,
        validator: "required",
        styleClasses:'col-lg-4 custom-input',
        selectOptions: {
          noneSelectedText: "Choose..."
        },
        onChanged: function(model, newVal, oldVal, field) {
          field.styleClasses = field.styleClasses + ' selected';
        }
      },
      {
        type: "cleave",
        inputType: "text",
        label: "Tax ID",
        model: "taxID",
        required: true,
        min: 10,
        validator: validators.string.locale({
          fieldIsRequired: "This field is required!",
          textTooSmall: "Please input a valid EIN."
        }),
        cleaveOptions: {
          blocks: [2, 7],
          delimiter: "-",
          numericOnly: true
        },
        styleClasses:'col-lg-4 custom-input'
      },
      {
        type: 'select',
        label: 'State of Inc.',
        model: 'stateOfIncorporation',
        values: ['Alabama','Alaska','Arizona','Arkansas','California','Colorado','Connecticut','Delaware','Florida','Georgia','Hawaii','Idaho','Illinois','Indiana','Iowa','Kansas','Kentucky','Louisiana','Maine','Maryland','Massachusetts','Michigan','Minnesota','Mississippi','Missouri','Montana','Nebraska','Nevada','New Hampshire','New Jersey','New Mexico','New York','North Carolina','North Dakota','Ohio','Oklahoma','Oregon','Pennsylvania','Rhode Island','South Carolina','South Dakota','Tennessee','Texas','Utah','Vermont','Virginia','Washington','West Virginia','Wisconsin','Wyoming'],
        styleClasses:'col-lg-4 custom-input',
        required:true,
        validator: "required",
        selectOptions: {
          noneSelectedText: "Choose..."
        },
        onChanged: function(model, newVal, oldVal, field) {
          field.styleClasses = field.styleClasses + ' selected';
        }
      },
    ]
   },
   aboutCompanySchema: {
     fields:[
       {
        type: 'select',
        label: 'Primary Business Activity',
        placeholder: 'Choose...',
        model: 'businessDescription',
        values: ['Equipment Leasing Broker','General ISO','Credit Card Processing / Sales','Cash Advance / Alternative Finance','Small Business Consultant','SBA Lender','Financial Services','Lead Generation','Vendor','Other'],
        styleClasses:'col-lg-4 custom-input',
        required:true,
        validator: "required",
        selectOptions: {
          noneSelectedText: "Choose..."
        },
        onChanged: function(model, newVal, oldVal, field) {
          field.styleClasses = field.styleClasses + ' selected';
        }
       },
       {
        type: 'input',
        inputType: 'number',
        model: "yearsInBusiness",
        label: 'Years in Business',
        required:true,
        validator: "required",
        styleClasses:'col-lg-4 custom-input'
       },
       {
        type: 'input',
        inputType: 'number',
        model: "numOfSales",
        label: 'Number of Salespeople',
        required:true,
        validator: "required",
        styleClasses:'col-lg-4 custom-input'
       }
     ]
   },
   lendingExpSchema: {
      fields:[
        {
          type: 'radios',
          label: 'Do you currently work with other lenders?',
          model: 'workWithOtherLenders',
          values:['Yes', 'No'],
          required: true,
          validator: "required",
          styleClasses:'col-lg-4 input-type-radio'
        },
        {
          type: "checklist",
          label: "What products do you currently offer customers?",
          model: "products",
          multi: true,
          required: true,
          multiSelect: true,
          values: ["None", "Cash Advance", "Equipment Lease", "Short Term Loan", "Line of Credit", "Commercial Real Estate Financing", "A/R Financing", "Mortgage"],
          styleClasses: 'col-lg-4 form-group-new-line'
        },
        {
          type: "textArea",
          rows: 4,
          inputType: "text",
          label: "How did you hear about us?",
          model: "howYouHearAboutUs",
          required: true,
          validator: ["string", "required"],
          styleClasses: 'col-lg-8 custom-input custom-lg-8'
        },
        {
          type: "textArea",
          rows: 4,
          inputType: "text",
          label: "Please provide the name and e-mail of two industry related references",
          model: "industryReferences",
          required: true,
          validator: ["string", "required"],
          styleClasses: 'col-lg-8 custom-input custom-lg-8'
        },
        {
          type: 'select',
          label: 'Anticipated applications / leads per month',
          placeholder: 'Choose...',
          model: 'leadsPerMonth',
          values: ['0-5','5-10','10+'],
          styleClasses:'col-lg-4 custom-input',
          required:true,
          validator: "required",
          selectOptions: {
            noneSelectedText: "Choose..."
          },
          onChanged: function(model, newVal, oldVal, field) {
            field.styleClasses = field.styleClasses + ' selected';
          }
        },
        {
          type: "checklist",
          label: "How do you communicate and acquire your customers?",
          model: "waysToGetCustomer",
          multi: true,
          required: true,
          multiSelect: true,
          values: ["Email Marketing", "Social Media", "Events", "Direct Mail", "Website Marketing", "Referrals", "Media Advertising", "Paid Search", "List Acquisition", "Other"],
          styleClasses: 'col-lg-4 bottom-checklist form-group-new-line'
        },
      ]
   }
  }
 },
 computed: {
    ...mapGetters({
      userInfo: types.GET_USER
    }),
    currentDate: function() {
      return moment(new Date()).format('MM/DD/YY');
    }
  },
  methods: {
    ...mapMutations({
      setUserInfo: types.SET_USER
    }),
    ...mapActions({
      setSuccessMessage: types.SET_SUCCESS_MESSAGE,
      setAlertMessage: types.SET_FAIL_MESSAGE,
      getPersonalInitData: types.GET_PERSONAL_INIT_DATA
    }),
    onComplete: function(){
      // alert('Yay. Done!');
      // return console.log(this.uploadedFiles);
      this.signup();
    },
    checkFileTypes(files) {
      var allTypesSelected = true;
      files.forEach(file => {
        if(!file.category || file.category == '') {
          allTypesSelected = false;
        }
      })
      return allTypesSelected;
    },

    signup() {

      if(this.model.products.length == 0) {
        return this.setAlertMessage({
                show: true,
                content: 'Please select the products you currently offer customers.'
               });
      }


      if(this.model.waysToGetCustomer.length == 0) {
        return this.setAlertMessage({
                show: true,
                content: 'Please select the way you communicate and acquire your customers.'
               });
      }

      //add loading animation after click submit
      Loading.service({ fullscreen: true, lock: true });
      // setTimeout(() => {
      //   Loading.service({ fullscreen: true, lock: true }).close();
      // }, 3000)

      var _this = this;
      var registerData = {
          firstName: _this.model.firstName,
          lastName: _this.model.lastName,
          middleName: '',
          email: _this.model.personalEmail,
          customerType: '8'
      }

      api.brokerRegisterUser(registerData)
      .then(res => {
        if (Number(res.data.code) == 0) {
          var data = res.data.data;
          _this.clientCustomerId = data.crmCustomerId;
          _this.clientCustomerToken = data.token;
          var str = data.crmCustomerLoginName
          if (str.indexOf('+1') >= 0) {
            data.crmCustomerLoginName = str.slice(2)
          }
          // Cookie.set('userData', encodeURIComponent(JSON.stringify(data)));
          // Cookie.set('customerId', data.crmCustomerId);
          // _this.setUserInfo(data);
          
          _this.saveBusinessOwner();
          return true;
        } else {
          Loading.service({ fullscreen: true, lock: true }).close();
          if (res.data.result === "Registration failed, email has been registered") {
            this.setAlertMessage({
              show: true,
              content: 'Failed to submit application, business owner email already exist'
            });
            // alert("Failed to submit application, business owner email already exist");
          }
          return false;
        }
      });
    },

    saveBusinessOwner() {
      var _this = this;
      var postData = {
        customerId: _this.clientCustomerId,
        tokenId: _this.clientCustomerToken,

        firstName: _this.model.firstName,
        lastName: _this.model.lastName,
        phone: _this.model.personalPhone,
        ssn: _this.model.ssn,
        streetAddress: _this.model.ownerAddress,
        streetAddressLine2: _this.model.ownerAddress2,
        cityName: _this.model.ownerCity,
        state: _this.model.ownerState,
        zipCode: _this.model.ownerZip,
        title: _this.model.title || "",
        dateOfBirth: _this.model.dateOfBirth.slice(6) + '-' + _this.model.dateOfBirth.slice(0,5),

        isValid: 1,
        customer_area: "",
        military: false
      }

      api
        .postForm(
          "/mobile/item/loanItemFrontApply/mgxyBrokerUpdateApplyForPersonDetails.ht",
          postData 
        )
        .then(res => {
          console.log(res);
          var _data = res.data;
          this.isLoading = false;
          if (_data.code == 0) {
            // this.setAlertMessage({
            //   show: true,
            //   content: "Success to save personal information"
            // });
            console.log("Success to save personal information");
            _this.submitBusinessInfo();
          } else {
            Loading.service({ fullscreen: true, lock: true }).close();
            this.setAlertMessage({
              show: true,
              content: _data.msg
            });
          }
        });
    },

    submitBusinessInfo() {
      var _this = this;
      var combinedBusinessDesc = _this.model.businessDescription + '^^' + _this.model.numOfSales + '^^' + _this.model.workWithOtherLenders + '^^' + _this.model.products.join(', ') + '^^' + _this.model.howYouHearAboutUs + '^^' + _this.model.industryReferences + '^^' + _this.model.leadsPerMonth + '^^' + _this.model.waysToGetCustomer.join(', ');
      api.postForm("/mobile/item/loanItemFrontApply/updateSBL.ht", {
        tokenId: _this.clientCustomerToken,
        customerId: _this.clientCustomerId,
        
        website: _this.model.website || '',
        name: _this.model.companyName,
        street: _this.model.address,
        city: _this.model.city,
        state: _this.model.state,
        zipCode: _this.model.zip,
        phone: _this.model.companyPhone,
        tin: _this.model.taxID,
        structure: _this.model.taxClassification,
        yearsInBusiness: _this.model.yearsInBusiness,
        businessDesc: combinedBusinessDesc,
        stateOfIncorporation: _this.model.stateOfIncorporation
      }).then(res => {
        Loading.service({ fullscreen: true, lock: true }).close();
        //             alert(res.date.code);
        //             alert(res.date.msg);
        var _data = res.data;
        if (_data.code == 0) {
          console.log(res);
          this.setSuccessMessage({
            show: true,
            content: "Sign up successful, we will review your request and get back to you soon"
          });

          //send thank you email to new partner
          axios.post("https://api.amcredit.com/apply/sendTransactionalEmail", {customerEmail: _this.model.personalEmail, firstName: _this.model.firstName, emailTemplate: 'partner-signup-thank-you', emailSubject: 'Thank you for choosing American Credit as your partner' })
          .then(res => {console.log(res)})
          .catch(err => console.log(err.message));

          //send new partner signup notification
          axios.post("https://api.amcredit.com/apply/sendNotificationEmail", {emailSubject: 'New Partner Signup Notification', customerName: _this.model.firstName, customerEmail: _this.model.personalEmail, emailTemplate: 'partner-signup-notification' })
          .then(res => console.log(res))
          .catch(err => console.log(err.message));

          //new partner signup slack notice webhook
          var partnerData = {
            name: _this.model.companyName,
            firstName: _this.model.firstName,
            lastName: _this.model.lastName,
            phone: _this.model.companyPhone,
            email: _this.model.personalEmail
          };
          axios.create({ transformRequest: [(data, _headers) => JSON.stringify(data)] })
                  .post('https://hooks.zapier.com/hooks/catch/11204908/bpyj6pb/',partnerData);

          setTimeout(function() {
            _this.$router.push({
              path: '/'
            });
            // window.location.reload(true);
          }, 3000);
          console.log("Success to save business information");
          _this.submitVendorForm();
        } else {
          this.setAlertMessage({
            show: true,
            content: _data.msg
          });
        }
      });
    },

    createOrUpdateHubspotContact (applied) {
      var _this = this;
      // hubspot create new contact
      // POST request using axios with set headers

      var dataProperties = [
        { property: 'applied_successfully', value: applied },
        { property: 'website_new_apply_tag', value: 'Website new application process leads' },
        { property: 'applied_product', value: 'SBEL_product' },
        { property: 'company', value: _this.model.companyName },
        { property: 'business_phone', value: _this.model.companyPhone },
        { property: 'business_structure_transmit', value: _this.model.taxClassification },
        { property: 'business_address', value: _this.model.address },
        { property: 'business_city', value: _this.model.city },
        { property: 'business_state_transmit', value: _this.model.state },
        { property: 'business_zip_code', value: _this.model.zip },
        { property: 'firstname', value: _this.model.firstName },
        { property: 'lastname', value: _this.model.lastName },
        { property: 'address', value: _this.model.ownerAddress },
        { property: 'city', value: _this.model.ownerCity },
        { property: 'state', value: _this.model.ownerState },
        { property: 'zip', value: _this.model.ownerZip },
        { property: 'phone', value: _this.model.personalPhone },
        { property: 'ownership_percentage', value: _this.model.ownership },
        { property: 'first_name_person_2', value: _this.model.owner2FirstName },
        { property: 'last_name_person_2', value: _this.model.owner2LastName },
        { property: 'street_address_person_2', value: _this.model.owner2Address },
        { property: 'city_person_2', value: _this.model.owner2City },
        { property: 'state_person_2_transmit', value: _this.model.owner2State },
        { property: 'postal_code_person_2', value: _this.model.owner2Zip },
        { property: 'phone_person_2', value: _this.model.owner2PersonalPhone },
        { property: 'ownership_person_2', value: _this.model.owner2PersonalEmail }
      ];

      if(_this.model.equipmentCost != '') {
        dataProperties.push({ property: 'deal_amount', value: _this.model.equipmentCost });
      }

      // if(_this.model.term != '') {
      //   dataProperties.push({ property: 'deal_loan_term', value: _this.model.term });
      // }

      console.log(dataProperties)

      const body = {
        email: _this.model.personalEmail,
        data: {
          properties: dataProperties
        }
      }
      const headers = {
        'Content-Type': 'application/json'
      }

      axios({
        url: '/hsapi/create_or_update_contact',
        method: 'post',
        baseURL: 'https://api.amcredit.com/hubspot',
        data: body,
        headers: headers
      })
        .then(response => console.log(response))
        .catch(error => console.log(error.message))
    },


    scrollToTop: function() {
      window.scrollTo(0,0);
    },

    validateFirstTab: function(){
      // return true;
      return this.$refs.businessOwnerForm.validate() && this.$refs.companyInfoForm.validate() && this.$refs.aboutCompanyForm.validate() && this.$refs.lendingExpForm.validate();
    },
    validateSecondTab: function(){
      // return true;

      var _this = this;
      let valid_owner = this.$refs.secondTabForm.validate(),
          valid_owner_address = true,
          valid_owner2 = true,
          valid_owner2_address = true;

      if(!_this.toggle) {
        valid_owner_address = this.$refs.mailingAddressForm.validate();
      }

      if(_this.showOwner2) {
        valid_owner2 = this.$refs.addOwnerForm.validate();
        if(!_this.owner2Toggle) {
          valid_owner2_address = this.$refs.mailingAddress2Form.validate();
        }
      }

      return valid_owner && valid_owner_address && valid_owner2 && valid_owner2_address;
    },

    validateConsentTab: function(){
      if(this.consentToggle) {
        this.signAgreement();
        return true;
      } else {
        this.setAlertMessage({
          show: true,
          content: 'You need to review and agree with the consent clauses to proceed.'
        });
        return false;
      }
      
    },

    signAgreement() {
      const _this = this;
      var fullName = _this.model.firstName + ' ' + _this.model.lastName;
      api
        .postForm(
          "/mobile/item/loanItemFrontApply/mgxyConfirmSignDeclaration.ht",
          {
            tokenId: _this.clientCustomerToken,
            contractId: 10000058500118,
            fullName: fullName
          }
        )
        .then(res => {
          const data = res.data;
          console.log(data.msg);
        });
    },

    addOwner: function(){
      var newAddOwner = {toggle: true}
      this.addOwners.push(newAddOwner);
    },

    deleteOwner: function(index){
      this.addOwners.splice(index, 1);
    },

    addOwner2: function(){
      this.showOwner2 = true;
    },

    deleteOwner2: function(index){
      this.showOwner2 = false;
    },

    editBusiness: function() {
      this.$refs.wizard.changeTab(3, 0);
    },

    editOwner: function() {
      this.$refs.wizard.changeTab(3, 1);
    }
  },    
  mounted() {
    if(this.$route.query.amount) {
      this.model.equipmentCost = Number(this.$route.query.amount);
    }
    if(this.$route.query.term) {
      this.model.loanTerm = this.$route.query.term * 12;
    }
    if(this.$route.query.equipment) {
      this.model.equipmentDescription = this.$route.query.equipment;
    }
    if(this.$route.query.yearsInBusiness) {
      this.model.yearsInBusiness = this.$route.query.yearsInBusiness;
    }
    console.log(this.userInfo);
    this.model.customerType = this.userInfo.crmCustomerType;
    if(this.model.customerType == '1') {
      this.model.personalEmail = this.userInfo.crmCustomerLoginName;
    }
    // this.getPersonalInitData({
    //   token: this.userInfo.token,
    //   customerId: this.userInfo.crmCustomerId
    // }).then(res => {
    //   console.log(res);
    //   if (Number(res.data.code) === 0) {
    //     const data = res.data.result;
    //     console.log(data);
    //   }
    // });
    var seo = document.getElementById("seo");

    var meta = document.getElementById("seometa");
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      meta.id = "seometa";
      document.head.insertBefore(meta, seo);
    }

    var keywords = document.getElementById("seokeywords");
    if (!keywords) {
      keywords = document.createElement("meta");
      keywords.name = "keywords";
      keywords.id = "seokeywords";
      document.head.insertBefore(keywords, seo);
    }

    document.title = "Partner with American Credit: Referral & Broker Programs";
    meta.content = "Join American Credit. Help clients secure financing, offer stellar customer experiences, and boost your revenue.";
    keywords.content = "American Credit Partners, Small Business Financing, Equipment Financing, Working Capital Financing";
  }
}
</script>

<style lang="scss" scoped>
  .reveal-overlay {
    font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
    font-weight: 400;
    line-height: 1.5;
    color: #053A7A;
    -webkit-font-smoothing: antialiased;
    margin: 0;
    padding: 0;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1005;
    background-color: rgba(0,0,0,.45);
    overflow-y: auto;
    display: block;
    #contact-modal {
      font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
      font-weight: 400;
      line-height: 1.5;
      color: #053A7A;
      -webkit-font-smoothing: antialiased;
      z-index: 1006;
      backface-visibility: hidden;
      padding: 2.5rem 2rem 1.5rem;
      border: 1px solid #787d78;
      border-radius: .25rem;
      background-color: #fff;
      position: relative;
      overflow-y: auto;
      min-height: 0;
      right: auto;
      left: auto;
      margin: 0 auto;
      outline: 0;
      width: 50%;
      max-width: 81.75rem;
      top: 41px;
      display: block;
      .close-button {
        margin: 0;
        overflow: visible;
        text-transform: none;
        padding: 0;
        border: 0;
        background: 0 0;
        appearance: none;
        border-radius: .25rem;
        position: absolute;
        z-index: 10;
        color: #413e37;
        cursor: pointer;
        right: 1rem;
        top: .5rem;
        font-size: 2em;
        line-height: 1;
        outline: 0;
      }
      h4 {
        -webkit-font-smoothing: antialiased;
        overflow-wrap: break-word;
        margin: 0;
        padding: 0;
        font-style: normal;
        text-rendering: optimizeLegibility;
        margin-top: 0;
        margin-bottom: .875rem;
        font-size: 1.5rem;
        line-height: 1.33333;
        font-family: Montserrat,sans-serif;
        font-weight: 600;
        letter-spacing: -.0375rem;
      }
      .intro {
        line-height: 1.5;
        margin: 0;
        padding: 0;
        font-family: Montserrat,sans-serif;
        color: #888;
        font-weight: 400;
        letter-spacing: -.00625rem;
        font-size: 16px;
        max-width: 100%;
      }
      .text-right {
        font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
        font-weight: 400;
        line-height: 1.5;
        color: #053A7A;
        -webkit-font-smoothing: antialiased;
        margin: 0;
        padding: 0;
        text-align: right;
        margin-bottom: 0;
        button {
          overflow: visible;
          background: 0 0;
          display: inline-block;
          vertical-align: middle;
          margin: 0 0 1rem 0;
          border: 1px solid transparent;
          transition: background-color .25s ease-out,color .25s ease-out;
          -webkit-appearance: none;
          cursor: pointer;
          // background-color: #91c855;
          // color: #053A7A;
          background-color: #5456ff;
          color: #fff;
          font-size: .75rem;
          line-height: 1rem;
          padding: .6875rem 1.5rem;
          border-radius: 1.25rem;
          letter-spacing: 1px;
          text-align: center;
          font-weight: 600;
          text-transform: uppercase;
          min-width: 9.75rem;
          outline: 0;
          height: auto;
        }
      }
    }
  }
  .important-notice {
    font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
    font-weight: 400;
    -webkit-font-smoothing: antialiased;
    margin: 0;
    padding: 0;
    color: #787d78;
    margin-bottom: 2.5rem;
    font-size: .75rem;
    line-height: 1rem;
    p {
      font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
    }
  }
  .agree-box {
    font-size: 100%;
    font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
    font-weight: 400;
    line-height: 1.5;
    color: #053A7A;
    -webkit-font-smoothing: antialiased;
    margin: 0;
    border-radius: .5rem;
    background-color: #f0f4f0;
    padding: 2.5rem;
    margin-bottom: 2.5rem;
    .consent-check-box {
      font-size: .75rem;
      line-height: 1rem;
      appearance: none;
    }

    .consent-check-label {
      font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
      -webkit-font-smoothing: antialiased;
      margin: 0;
      font-size: 1rem;
      line-height: 1.5rem;
      color: #053A7A;
      word-break: break-word;
      display: inline-block;
      vertical-align: baseline;
      margin-right: 1rem;
      margin-bottom: 1rem;
      position: relative;
      padding-left: 1.75rem;
      font-weight: 600!important;
      margin-left: .875rem;
      cursor: pointer;
    }

    .consent-check-label:before {
      background-image: url(../assets/imgs/checkbox.svg);
      width: 1.5rem;
      height: 1.5rem;
      position: absolute;
      top: 0.75rem;
      left: -0.75rem;
      content: '\A';
      background-repeat: no-repeat;
      background-size: contain;
      display: inline-block;
    }

    .checked:before {
      background-image: url(../assets/imgs/checkbox-checked.svg) !important;
    }
    .consent-sign {
      font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif !important;
      font-weight: 400;
      line-height: 1.5;
      color: #053A7A;
      -webkit-font-smoothing: antialiased;
      margin: 0;
      padding: 0;
      min-width: 0;
      padding-right: .75rem;
      padding-left: .75rem;
      flex: 0 0 33.33333%;
      max-width: 33.33333%;
      text-align: right;
      .text {
        font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif !important;
        font-weight: 400;
        line-height: 1.5;
        color: #053A7A;
        -webkit-font-smoothing: antialiased;
        text-align: right;
        margin: 0;
        padding: 0;
      }
    }
  }
  .consent-item-wrapper {
    margin-bottom: 2.5rem;
    .consent-item {
      padding: 2.5rem;
      border: 1px solid #c1c4c2;
      cursor: pointer;
      border-radius: 0.5rem;
      margin-bottom: 0.5rem;
      box-shadow: none;
      transition: box-shadow .1s ease-in-out;
      .media-wrap {
        margin-right: 1rem;
      }
      a {
        font-weight: 600;
        text-decoration: underline;
        color: #3282a0;
        cursor: pointer;
        font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
      }
    }
    .consent-item:hover {
        box-shadow: 0 0 16px rgba(0,0,0, 0.1);
    }
  }
  
  .flex-container {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
  }

  .align-middle {
      -webkit-align-items: center;
      -ms-flex-align: center;
      align-items: center;
  }
  .consent-title {
    margin-bottom: 0.8125rem !important;
  }
  .intro {
    font-size: 100%;
    line-height: 1.5;
    margin: 0;
    padding: 0;
    letter-spacing: -.03125rem;
    font-family: Montserrat,sans-serif;
    color: #787d78;
    font-weight: 400;
    margin-bottom: 2.5rem;
    max-width: 39.375rem;
  }

  #application-notes {
    overflow: auto;
    min-height: 50px;
    display: block;
    box-sizing: border-box;
    margin: 0 0 1rem;
    border-radius: .25rem;
    background-color: #f0f4f0;
    box-shadow: none;
    font-weight: 600;
    transition: box-shadow .5s,border-color .25s ease-in-out,padding-top .25s ease-in-out;
    appearance: none;
    max-width: 100%;
    padding: 1rem;
    font-size: 1rem;
    line-height: 1.5rem;
    color: #053A7A;
    width: 100%;
    margin-bottom: .5rem;
    border: 0;
    resize: vertical;
    height: auto;
    font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
  }

  #application-notes:focus {
    box-shadow: 0 0 0 1px #787d78;
    border: 0;
    outline: 0;
  }

  .remove-padding {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .review-section {
    .m-t-30 {
      margin-top: 1.875rem;
    }
    .amcredit-text {
      color: #053A7A;
      font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
    }
    .sub-title-margin {
      margin-top: 35px;
    }
    .review-item {
      border-top: 1px solid #e3e6e3;
      border-bottom: 1px solid #e3e6e3;
      padding: 0.25rem 0;
      margin: -1px 0 0 -1px;
      word-break: break-word;
      width: 100%;
      .item-title {
        max-width: 50%;
        -webkit-flex: 0 0 50%;
        -ms-flex: 0 0 50%;
        flex: 0 0 50%;
        font-size: .75rem;
        line-height: 1rem;
        padding: 0.75rem 0;
        color: #787d78;
        margin: 0;
        font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
      }
      .item-value {
        max-width: 50%;
        -webkit-flex: 0 0 50%;
        -ms-flex: 0 0 50%;
        flex: 0 0 50%;
        text-align: right;
        color: #053A7A;
        font-weight: 600;
        font-size: .75rem;
        line-height: 1rem;
        font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
        margin: auto;
      }
    }
    .edit-review {
      height: 1.5rem;
      min-width: 0;
      border: 1px solid #91c855;
      color: #053A7A;
      background-color: transparent;
      outline: 0;
      font-size: .625rem;
      line-height: 1rem;
      padding: 0.25rem 1rem;
      border-radius: 1.25rem;
      letter-spacing: 1px;
      text-align: center;
      font-weight: 600;
      position: absolute;
      right: 0;
      display: inline-block;
      vertical-align: middle;
      margin: 0 0 1rem 0;
    }
    .sub-title {
      color: #538e37;
      font-size: .625rem;
      line-height: 1rem;
      font-weight: 600;
      letter-spacing: .0625rem;
      text-transform: uppercase;
    }
  }
  .delete-add-owner {
    font-size: 20px;
    color: #3282a0;
    text-decoration: none;
    cursor: pointer;
    margin-left: 46%;
  }

  .amcredit-add-owner {
    border: 1px solid #00234D;
    color: #053A7A;
    font-size: .75rem;
    line-height: 1rem;
    padding: 0.6875rem 1.5rem;
    border-radius: 1.25rem;
    letter-spacing: 1px;
    text-align: center;
    font-weight: 600;
    text-transform: uppercase;
    min-width: 9.75rem;
  }
  .amcredit-add-owner:hover {
    border-color: #005fcc;
  }

  .address-check-box {
    font-size: .75rem;
    line-height: 1rem;
    appearance: none;
  }

  .address-check-label {
    cursor: pointer;
    font-weight: 400;
    margin-bottom: 0;
    position: relative;
    padding-left: 1.75rem;
    display: inline-block;
    vertical-align: baseline;
    margin-left: 0.5rem;
    margin-right: 1rem;
    line-height: 1.5rem;
    color: #053A7A;
    font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
  }

  .address-check-label:before {
    background-image: url(../assets/imgs/checkbox.svg);
    width: 1.5rem;
    height: 1.5rem;
    position: absolute;
    top: 0;
    left: -0.5rem;
    content: '\A';
    background-repeat: no-repeat;
    background-size: contain;
    display: inline-block;
  }

  .checked:before {
    background-image: url(../assets/imgs/checkbox-checked.svg) !important;
  }

  hr {
    clear: both;
    height: 0;
    margin: 1.375rem 0;
    border-top: 0;
    border-right: 0;
    border-bottom: 1px solid #c1c4c2;
    border-left: 0;
  }

  label:empty {
      display: none;
  }
  @media print, screen and (min-width: 64em) {
    .minimal-title {
      position: absolute;
      left: 50%;
      -webkit-transform: translateX(-50%);
      -ms-transform: translateX(-50%);
      transform: translateX(-50%);
      padding-bottom: 30px;
    }
  }
  .ls-1 {
    letter-spacing: .0625rem;
  }
  .text-12-16 {
      font-size: .75rem;
      line-height: 1rem;
  }
  .f-w-600 {
      font-weight: 600;
  }
  .uppercase {
      text-transform: uppercase;
  }
  .color-gray-5, .color-grey-5 {
      color: #053A7A;
  }
  .text-center {
      text-align: center;
  }
  .amcredit-font {
      font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
      /* font-weight: 400; */
      line-height: 1.5;
      color: #053A7A;
  }
  h3.title {
    margin-bottom: 2.5rem;
    letter-spacing: -.03125rem;
    max-width: 39.375rem;
    font-family: Montserrat,sans-serif;
    font-weight: 600;
    color: #053A7A;
  }
  h5.color-green {
    margin-top: 0;
    margin-bottom: 0.875rem;
    font-size: 1.25rem;
    line-height: 1.6;
    letter-spacing: -.03125rem;
    font-family: Montserrat,sans-serif;
    font-weight: 600;
    color: #5456ff;
  }
  @media screen and (max-width: 768px) {
    .reveal-overlay {
      #contact-modal {
        width: 90%;
        h4 {
          font-size: 1.5rem !important;
        }
      }
    }
    .agree-box .consent-sign {
      margin-left: 32px;
    }
    .review-section {
      padding-right: 0 !important;
      margin-right: 0 !important;
      margin-left: -7.5px !important;
      .review-item .item-value {
        padding-right: 0 !important;
      }
      .edit-review {
        bottom: 0;
      }
      .sub-title-margin:nth-of-type(2) {
        margin-top: 0;
      }
    }
  }

</style>

<style lang="scss">
  .form-group-new-line {
    display: block !important;
    .form-control {
      color: #c02233 !important;
    }
  }
  .partner-signup {
    margin-bottom: 2.5rem;
    .wizard-nav.wizard-nav-pills {
      display: none;
    }
  }
  .dropList {
    background: #f2f1f2;
    z-index: 999999;
    position: absolute;
    left: 0;
    border-radius: 10px;
    width: 100%;
    // overflow: scroll !important;
    max-height: 500px !important;
    .list-row {
      margin: 20px;
    }
  }
  .bottom-checklist .dropList {
    bottom: 30px;
  }
  .has-error .errors{
    color: red;
    span {
      font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
      font-size: 12px;
    }
  }
  .vue-form-wizard .wizard-header {
    padding-bottom: 40px !important;
  }
  .fa-hospital:before {
    content: "1 Equipment & Business Information" !important;
    height: 16px;
    font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
    font-size: 12px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
  }
  .fa-sun:before {
    content: "2 Owner Information" !important;
    height: 16px;
    font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
    font-size: 12px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
  }
  .fa-consent:before {
    content: "3 Consent" !important;
    height: 16px;
    font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
    font-size: 12px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
  }
  .fa-rev:before {
    content: "4 Review" !important;
    height: 16px;
    font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
    font-size: 12px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
  }
  .wizard-nav.wizard-nav-pills > li a .wizard-icon{
    color: #787d78;
  }
  .wizard-nav.wizard-nav-pills > li.active a .wizard-icon{
    color: #053A7A !important;
  }
  .wizard-nav.wizard-nav-pills > li:first-child a {
      border-left: 0;
  }
  .wizard-nav.wizard-nav-pills > li:last-child a {
      border-right: 0;
  }
  .wizard-nav.wizard-nav-pills > li a {
    border-left: 1px solid rgba(0,0,0,.1);
    border-right: 1px solid rgba(0,0,0,.1);
  }
  .vue-form-wizard .wizard-tab-content {
    padding-top: 60px !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .vue-form-generator .form-group {
    padding-left: 0;
    padding-right: 0;
  }
  .vue-form-generator .form-group label{
    font-weight: 400;
    margin-bottom: 0.625rem;
    word-break: break-word;
    display: block;
    margin: 0;
    font-size: 1rem;
    line-height: 1.5rem;
    color: #053A7A;
    margin-bottom: 0.625rem;
  }
  .vue-form-generator .form-group label span {
    font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
  }

  .radio-list label {
      position: relative;
      padding: 1rem 1.5rem;
      /* width: 12.8125rem; */
      display: inline-block !important;
      margin: 0 0 1rem 0;
      font-size: .75rem;
      line-height: 1rem;
      font-weight: 600!important;
      display: inline-block;
      background: #f0f4f0;
      border-radius: 0.25rem;
      border: 1px solid transparent;
      width: 49.5%;
      color: #053A7A;
      height: 3.4375rem;
  }

  .radio-list label:first-child {
    margin-right: 0.5%;
  }
  .radio-list label:last-child {
    margin-left: 0.5%;
  }

  .input-type-radio {
    .field-wrap {
      display: block !important;
    }
    input {
      margin-right: 10px;
    }
  }
  
  .input-type-number{
    input {
      height: 3.4375rem;
      margin: 0 0 0.625rem;
      padding: 1rem;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      border: 0;
      border-radius: 0.25rem;
      background-color: #f0f4f0;
      font-size: 1rem;
      font-weight: 600;
      line-height: 1.5;
      color: #053A7A;
      background-origin: content-box;
      background-position: right -1rem center;
      background-repeat: no-repeat;
      background-size: 9px 6px;
      padding-right: 1.5rem;
      transition: box-shadow .5s,border-color .25s ease-in-out,padding-top .25s ease-in-out;
    }
  }

  .custom-input label[for="business-information"],
  .custom-input label[for="company-information"],
  .custom-input label[for="legal--financial"],
  .custom-input label[for="accounts-receivable-information"],
  .custom-input label[for="property-information"],
  .custom-input label[for="loan-information"] {
    margin-top: 0;
    margin-bottom: 0.875rem;
    font-size: 1.25rem;
    line-height: 1.6;
    letter-spacing: -.03125rem;
    font-family: Montserrat,sans-serif;
    font-weight: 600;
    color: #5456ff;
  }

  .custom-input {
    display: inline-block;
    margin-right: 0.25%;
    margin-bottom: 0 !important;
  }

  .custom-lg-8 {
    max-width: 66.916667% !important;
  }

  .custom-input select{
    margin-bottom: 0.625rem !important;
  }

  .custom-input input{
    height: 3.4375rem;
    margin: 0 0 0.625rem;
    padding: 1rem;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border: 0;
    border-radius: 0.25rem;
    background-color: #f0f4f0;
    font-size: 1rem !important;
    font-weight: 600;
    line-height: 1.5;
    color: #053A7A !important;
    background-origin: content-box;
    background-position: right -1rem center;
    background-repeat: no-repeat;
    background-size: 9px 6px;
    padding-right: 1.5rem;
    transition: box-shadow .5s,border-color .25s ease-in-out,padding-top .25s ease-in-out;
  }

  .field-wrap .combobox {
    height: 3.4375rem;
    margin: 0;
    padding: 1rem;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border: 0;
    border-radius: 0.25rem;
    background-color: #f0f4f0;
    font-size: 1rem;
    font-weight: 600;
    line-height: 1.5;
    color: #6c757d;
    background-origin: content-box;
    background-position: right -1rem center;
    background-repeat: no-repeat;
    background-size: 9px 6px;
    padding-right: 1.5rem;
    transition: box-shadow .5s,border-color .25s ease-in-out,padding-top .25s ease-in-out;
  }

  .field-wrap select {
    height: 3.4375rem;
    margin: 0 0 1.75rem;
    padding: 1rem;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border: 0;
    border-radius: 0.25rem;
    background-color: #f0f4f0;
    font-size: 1rem !important;
    font-weight: 600;
    line-height: 1.5;
    color: #6c757d;
    background-origin: content-box;
    background-position: right -1rem center;
    background-repeat: no-repeat;
    background-size: 9px 6px;
    padding-right: 1.5rem;
    transition: box-shadow .5s,border-color .25s ease-in-out,padding-top .25s ease-in-out;
  }

  .field-select.selected select  {
    color: #053A7A;
  }
  .wizard-card-footer {
    padding: 0 !important;
  }
  .vue-form-wizard .wizard-card-footer .wizard-footer-left {
    display: none;
  }

  .vue-form-wizard .wizard-card-footer .wizard-footer-right {
    float: left !important;
  }
  .wizard-footer-right .wizard-btn{
    font-size: .75rem !important;
    line-height: 1rem !important;
    padding: 0.6875rem 1.5rem !important;
    border-radius: 1.25rem !important;
    letter-spacing: 1px !important;
    text-align: center !important;
    font-weight: 600 !important;
    text-transform: uppercase !important;
    min-width: 9.75rem !important;
    background-color: #5456ff !important;
    color: #fff !important;
    border: 0 !important;
    max-width: 26.25rem !important;
    width: 420px !important;
    margin-top: 10px !important;
    margin-bottom: 40px !important;
    font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
  }
  @media screen and (max-width: 768px) {
    .custom-lg-8 {
      max-width: 100% !important;
    }
    .wizard-footer-right .wizard-btn {
      width: 100% !important;
    }
  }
  
</style>


// WEBPACK FOOTER //
// PartnerSignUp.vue?eb51c97a